export default "__VITE_ASSET__BjUVAiI$__"